export enum VideosDashboardTypes {
  FETCH_VIDEOS_START = 'FETCH_VIDEOS_START',
  FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS',
  FETCH_VIDEOS_FAILURE = 'FETCH_VIDEOS_FAILURE',
  UPDATE_VIDEO_START = 'UPDATE_VIDEO_START',
  UPDATE_VIDEO_SUCCESS = 'UPDATE_VIDEO_SUCCESS',
  UPDATE_VIDEO_FAILURE = 'UPDATE_VIDEO_FAILURE',
}
